import { render } from "./TaikyoNotificationList.vue?vue&type=template&id=312e5f60&scoped=true&ts=true"
import script from "./TaikyoNotificationList.vue?vue&type=script&lang=ts"
export * from "./TaikyoNotificationList.vue?vue&type=script&lang=ts"

import "./TaikyoNotificationList.vue?vue&type=style&index=0&id=312e5f60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312e5f60"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTime from 'quasar/src/components/time/QTime.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTd,QIcon,QInput,QPopupProxy,QDate,QBtn,QSelect,QTime,QDialog,QCard,QCardSection,QFile,QCardActions,QField});qInstall(script, 'directives', {ClosePopup});
